import type { ReactNode } from "react";
import type { ApiPlayable } from "@hive/sdk";
import type { CatalogueSize } from "../../lib/catalogueLayout";
import type { ContentProperties } from "../../lib/analytics";
import { DistributionCard } from "./DistributionCard";
import { ContinuousCatalogueGrid } from "./ContinuousCatalogueGrid";

export function CatalogueGrid({ items, properties, renderCard, ordered = false, pattern, seed = items[0]?.id ?? "catalogue" }: {
	items: ApiPlayable[];
	seed?: string;
	properties: (item: ApiPlayable, index: number) => ContentProperties;
	renderCard?: (item: ApiPlayable, index: number, size: CatalogueSize) => ReactNode;
	ordered?: boolean;
	pattern?: number;
}) {
	const card = ({ item, sourceIndex, size = "small" }: { item: ApiPlayable; sourceIndex: number; size?: CatalogueSize }) => renderCard ? renderCard(item, sourceIndex, size) : <DistributionCard
		key={item.id + ":" + sourceIndex} item={item} properties={properties(item, sourceIndex)}
		coverSizes={size === "large" ? "280px" : "164px"} />;
	if (ordered) return <div className="catalogue-gallery"><div className="discover-category-grid">{items.map((item, sourceIndex) => card({ item, sourceIndex }))}</div></div>;
	return <ContinuousCatalogueGrid items={items} seed={seed} pattern={pattern} card={card} />;
}
